import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import { colors } from '../../constants/styleConstants';

const useStyles = makeStyles(theme => ({
  h2: {
    fontSize: 50,
    color: colors.title,
    display: 'inline-block',
    '& *': {
      fontFamily: 'inherit',
      color: 'inherit',
      fontSize: 'inherit',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 35,
      // fontSize: fontSize.h6,
    },
  },
}));

const H2 = ({ children, className }) => {
  const classes = useStyles();
  return <h2 className={classnames(classes.h2, className)}>{children}</h2>;
};

H2.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  className: PropTypes.string,
};

export default H2;
